<template>
<div class="chapter">
<div class="inner_page">
<h1 class="section">P<span class="smallcaps">ROLOGUE</span></h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// for-all-the-gold-in-the-world_00002.vue?1410927a